import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";

export default class HistoriaTabContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }


    render() {

        return (
          <div>
              <Row>
                  <Col xs={12}>
                    historia
                  </Col>
              </Row>
          </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/components/HistoriaTabContainer.js